import { ProfileInfoType } from '../../../types/profile';
import { MapPin } from 'lucide-react';

interface LocationSectionProps {
    profileInfo: ProfileInfoType
}

const LocationSection = ({ profileInfo }: LocationSectionProps) => {
    if (!profileInfo?.location?.displayText) return null;

    return (
        <div className="flex items-center justify-center text-center">
            <div className="flex items-center gap-1">
                <MapPin size={16} className="text-gray-500" />
                <span className="font-nunito text-[16px] font-medium text-gray-500">
                    {profileInfo?.location?.displayText}
                </span>
            </div>
        </div>
    );
};

export default LocationSection;
